import { Component, OnInit } from '@angular/core';
import { MatLinkPreviewService } from '@angular-material-extensions/link-preview';
import { ConfirmDialogModel, ConfirmationDialogComponent } from 'src/app/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-blog-and-notification',
  templateUrl: './blog-and-notification.component.html',
  styleUrls: ['./blog-and-notification.component.scss']
})
export class BlogAndNotificationComponent implements OnInit {
  private ResponseBlogList: Subject<any> = new Subject();

  uploadedImages: any;
  url: string | ArrayBuffer;
  addBlogForm: FormGroup;
  notifiction: FormGroup;
  BlogCount: number;
  blogpage = 1;
  BlogList: any = [];
  bloglimit = 10;
  Notilimit = 10;
  Documentlimit = 10;
  Documentoffset = 0;
  search  = "";
  blogOffset = 0;
  NotiOffset = 0;
  linkDetails = []
  VideoPage = 1;
  documentPage = 1
  data: any;
  NotificationCount: number;
  NotificationList: any[];
  DocumentList: any[];
  Tab: any;
  NotificationTab: any;
  DocumentCount: any;
  role: any;
  roleName: any;
  SadminAccess: any = [];
  access: any;
  constructor(private fb: FormBuilder, public linkPreviewService: MatLinkPreviewService, private dialog: MatDialog, private dashbord: DashboardService, private toastr: ToastrService, private router: Router, ) {
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    }else if (this.role == '5') {
      this.roleName = 'slave_admin';
    }
  }

  ngOnInit() {
    this.SadminAccess = JSON.parse(localStorage.getItem('SadminAccess') || '[]');

    if (localStorage.SadminAccess != undefined) {
      this.SadminAccess.forEach(x => {
        if (x.menu_name == 'Blog & Notification') {
          this.access = x.access
        }
      })
    }
    this.Tab = 'blog';
    this.NotificationTab = 'video';
    //reactive form validation
    this.addBlogForm = this.fb.group({
      url: ['', [Validators.required, Validators.pattern("https?://.+")]],

    });
    this.notifiction = this.fb.group({
      type: ['1', [Validators.required]],
      url: ['', [Validators.required]]
    })


    this.getBlogList(this.search, this.bloglimit, this.blogOffset);

    // this.linkPreviewService.fetchLink('https://www.askbhagwan.org/#/auth').subscribe(res => console.log('response: ', res));
  }

  //reactive form control function
  get f() { return this.addBlogForm.controls; }
  get f1() { return this.notifiction.controls; }

  // blog tab
  showBlogTab(tab) {
    this.Tab = tab;
    this.blogOffset=0;
    this.getBlogList(this.search, this.bloglimit, this.blogOffset);
    }
  // notification tab
  showNotificationTab(tab) {
    this.Tab = tab;
    this.NotificationTab = 'video';
    this.NotiOffset=0;
    this.getAllVedioList(this.search, this.Notilimit, this.NotiOffset)
     }
  // show video tab
  showNotificationVideoTab(tab) {
    this.NotificationTab = tab;
    this.NotiOffset=0;
    this.getAllVedioList(this.search, this.Notilimit, this.NotiOffset);

  }
  // show Document tab
  showNotificationDocumentTab(tab) {
    this.NotificationTab = tab;
    this.Documentoffset=0;
    this.getAllDocumentsList(this.search, this.Documentlimit, this.Documentoffset);
   }

  public confirmDialog(id: any): void {
    let message = "Are you sure you want to delete this Blog?";
    let title = "Confirm Action";
    const dialogData = new ConfirmDialogModel(title, message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteBlogbyId(id);
      }
    });
  }
  // get allblogList
  getBlogList(search, limit, offset) {
    if (offset == 0) {
      this.blogpage = 1;
    }

    var dataObject = {
      search: search,
      limit: limit,
      offset: offset
    }

    this.dashbord.getAllBlog(dataObject)
      .pipe(takeUntil(this.ResponseBlogList))
      .subscribe(
        async data => {
          this.BlogCount = 0;
          this.BlogList = [];
          this.linkDetails = [];
          if (data.status) {
            this.BlogCount = data.count;
            this.BlogList = data.resultObject;
           } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }

  // delete blog
  deleteBlogbyId(id, ) {
    var dataObject = {
      blog_id: id,
    }
    this.dashbord.deleteBlogById(dataObject)
      .pipe(takeUntil(this.ResponseBlogList))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success(data.message);
            this.getBlogList(this.search, this.bloglimit, this.blogOffset);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );

  }


  // add blog
  add_Blog() {
    var dataObject = {
      url: this.addBlogForm.controls['url'].value,
    }
    this.dashbord.addBlog(dataObject)
      .pipe(takeUntil(this.ResponseBlogList))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success(data.message);
            this.addBlogForm.reset();
            this.getBlogList(this.search, this.bloglimit, 0);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // pagination for blog
  nextPageforBlog(page) {
    this.blogOffset = (page - 1) * 10;
    this.getBlogList(this.search, this.bloglimit, this.blogOffset);
  }
  // pagination for notification video
  nextPageForVideo(page) {
    this.NotiOffset = (page - 1) * 10;
    this.getAllVedioList(this.search, this.Notilimit, this.NotiOffset);
  }
  // pagination for notification document
  nextPageForDocument(page) {
    this.Documentoffset = (page - 1) * 10;
    this.getAllDocumentsList(this.search, this.Documentlimit, this.Documentoffset);
  }
  onFileChange(event) {
    if (event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = e => this.url = reader.result;
      reader.readAsDataURL(file);
      this.uploadedImages = event.target.files;
      if (this.uploadedImages[0].type == "application/pdf") {
        this.uploadDocument();
      } else {
        this.toastr.info("Please select pdf document only");
        event.srcElement.value = null;
      }
    }
  }

  // upload document for notification
  uploadDocument() {
    this.dashbord.uploadPdfFile(this.uploadedImages)
      .then(
        async data => {
          if (data.status === true || data.status === 'true') {
            this.notifiction.patchValue({
              url: data.resultObject
            })
            this.toastr.success("File uploaded successfully...");

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.notifiction.controls['url'].reset()
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // change Radio Button
  changeRadioButton() {
    this.notifiction.controls['url'].reset();
  }

  // add notification
  add_Notifiction() {
    var notifictionObj = {
      url: this.notifiction.controls['url'].value,
      type: this.notifiction.controls['type'].value
    }
    this.dashbord.add_notifiction(notifictionObj)
      .pipe(takeUntil(this.ResponseBlogList))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success(data.message);
            this.notifiction.controls['url'].reset();
            if (this.notifiction.controls['type'].value == 1 || this.notifiction.controls['type'].value == "1") {
              this.getAllDocumentsList(this.search, this.Documentlimit, 0);
            } else {
              this.getAllVedioList(this.search, this.Notilimit, 0);
            }
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // get all video
  getAllVedioList(search, limit, offset) {
    if (offset == 0) {
      this.VideoPage = 1;
    }
    var dataObject = {
      search: search,
      type: 2,
      limit: limit,
      offset: offset
    }
    this.dashbord.getAllnotifiction(dataObject)
      .pipe(takeUntil(this.ResponseBlogList))
      .subscribe(
        async data => {
          this.NotificationCount = 0;
          this.NotificationList = [];
          var videoList = [];
          if (data.status) {
            this.NotificationCount = data.count;
            videoList = data.resultObject;
            for (let i = 0; i < videoList.length; i++) {
              if (videoList[i].type == 2) {
                if (videoList[i].url) {
                  videoList[i].url = videoList[i].url.replace('watch?v=', 'embed/');
                }
                this.NotificationList.push(videoList[i]);
              }
            }
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );

  }

  // get all Documents List
  getAllDocumentsList(search, limit, offset) {
   var dataObject = {
      search: search,
      type: 1,
      limit: limit,
      offset: offset
    }
    this.dashbord.getAllnotifiction(dataObject)
      .pipe(takeUntil(this.ResponseBlogList))
      .subscribe(
        async data => {
          this.DocumentCount = 0;
          this.DocumentList = [];
          if (data.status) {
            this.DocumentCount = data.count;
            this.DocumentList = data.resultObject;
            } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }
  // delete notification dilog box
  public DeleteNotificationDialog(id: any, type: any): void {
    if (type == 1 || type == "1") {
      var message = "Are you sure you want to delete this Document?";
    } else {
      var message = "Are you sure you want to delete this Video?";
    }

    let title = "Confirm Action";
    const dialogData = new ConfirmDialogModel(title, message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteNotificationbyId(id, type);
      }
    });
  }

  // delete notification
  deleteNotificationbyId(id, type) {
    var dataObject = {
      notification_id: id,
    }
    this.dashbord.deleteNotificationById(dataObject)
      .pipe(takeUntil(this.ResponseBlogList))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success(data.message);
            if (type == 1 || type == "1") {
              this.getAllDocumentsList(this.search, this.Documentlimit, this.Documentoffset);
            } else {
              this.getAllVedioList(this.search, this.Notilimit, this.NotiOffset);
            }

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }
  ngOnDestroy() {
    this.ResponseBlogList.next();
    this.ResponseBlogList.complete();
  }
}
